import { render, staticRenderFns } from "./colaboradores.vue?vue&type=template&id=400ae1ca&scoped=true&"
import script from "./colaboradores.vue?vue&type=script&lang=js&"
export * from "./colaboradores.vue?vue&type=script&lang=js&"
import style0 from "./colaboradores.vue?vue&type=style&index=0&id=400ae1ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400ae1ca",
  null
  
)

export default component.exports